import { ServicePerval } from '../../models/service-perval';
import { ServicePervalItemHttp } from '../service-perval.service';
import { getPropertyTypeFromCode } from '../../../shared/mappers/property-type.mapper';
import {
  getServicePervalName,
  getServicePervalUrl,
} from './service-perval-name.mapper';

export const fromServicePervalHttpToDomain = (
  servicePervalHttp: ServicePervalItemHttp,
): ServicePerval => ({
  happenedAt: new Date(servicePervalHttp.happened_at),
  name: getServicePervalName(servicePervalHttp.service),
  propertyType: getPropertyTypeFromCode(servicePervalHttp.property_type),
  street: servicePervalHttp.street,
  city: servicePervalHttp.city,
  postalCode: servicePervalHttp.postal_code,
  historyId: servicePervalHttp.history_id,
  evaluationId: servicePervalHttp.evaluation_id,
  url: getServicePervalUrl(
    servicePervalHttp.service,
    servicePervalHttp.history_id,
    servicePervalHttp.evaluation_id,
  ),
  reportId: servicePervalHttp.report_id,
});
